import { FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';

// Local whitespace validator to avoid external component dependency
export const noWhitespaceValidator: ValidatorFn = (control: AbstractControl) => {
    const value = control.value;
    if (value == null) return null; // nothing to validate
    const str = value.toString();
    if (str === '') return null; // vacío permitido (lo gestionará required si existe)
    // Si tiene caracteres pero tras trim queda vacío => sólo espacios
    if (str.trim().length === 0) return { whitespace: true };
    return null;
};

// Updates postal code validators dynamically based on the selected country
export function updatePostalCodeValidators(registrationForm: FormGroup, countryCode: string | null): void {
    if (!registrationForm) return;

    const control = registrationForm.get('postalCode');
    if (!control) return;

    // Limpiar siempre antes de aplicar nueva estrategia
    control.clearValidators();

    // Si no hay país seleccionado, dejamos el campo opcional (solo trim) y salimos
    if (!countryCode) {
        control.setValidators([noWhitespaceValidator]);
        control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
        return;
    }

    // Normalizamos el código de país
    const key = countryCode.toUpperCase();

    const patterns: Record<string, RegExp> = {
        'ES': /^\d{5,8}$/, 'ESP': /^\d{5,8}$/,
        'MX': /^\d{5,8}$/, 'MEX': /^\d{5,8}$/,
        // 'PE': /^\d{5,8}$/,
        // 'CL': /^\d{4,7}$/,
        // 'CR': /^\d{4,5}$/,
        // 'PA': /^\d{4,5}$/,
        // 'GT': /^\d{4,5}$/,
        // 'HN': /^\d{4,5}$/,
        // 'DO': /^\d{4,5}$/,
        // 'SV': /^\d{4,5}$/,
        // 'NI': /^\d{4,5}$/,
        'US': /^\d{5}(-\d{4})?$/, 'USA': /^\d{5}(-\d{4})?$/,
        'CA': /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
        'BR': /^\d{5}-?\d{3}$/,
        'AR': /^[A-Za-z]\d{4}[A-Za-z]{3}$/,
        'GB': /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i,
        'UK': /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i,
        'DE': /^\d{5}$/,
        'FR': /^\d{5}$/,
        'IT': /^\d{5}$/,
        'PT': /^\d{4}-?\d{3}$/
    };

    const selectedPattern = patterns[key] || null;

    // Validator to allow only digits (no letters, no spaces, no special chars)
    const digitsOnlyPattern = /^\d+$/;

    if (selectedPattern) {
        // País soportado: requerido + patrón específico + solo dígitos
        control.setValidators([
            Validators.required,
            Validators.pattern(selectedPattern),
            Validators.pattern(digitsOnlyPattern),
            noWhitespaceValidator
        ]);
    } else {
        // País no soportado: opcional, pero si introduce valor debe ser solo dígitos
        control.setValidators([
            noWhitespaceValidator,
            Validators.pattern(digitsOnlyPattern)
        ]);
    }
    control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
}